<template>
  <div class="pt-page pt-page-current pt-page-portsub pt-page-7 show-overflow">
    <router-link class="top-nav" to="/portfolio"><i class="fa fa-arrow-left"></i></router-link>
    <a class="logo" href="/">OM</a>
    <div class="portsub-container text-center">
      <div class="container">
        <div class="col-md-6">
          <div class="mac-screen-container">
            <div class="mac-screen-slider">
              <div>
                <img src="../assets/images/cravely-1.jpg" alt="#">
              </div>
              <div>
                <img src="../assets/images/cravely-2.jpg" alt="#">
              </div>
            </div>
            <img src="../assets/images/mac-screen-medium.png" alt="Mac Screen" class="mac-screen">
          </div>
          <div class="mac-screen-slider-dots"></div>
        </div>
        <div class="col-md-6 portsub-right">
          <h1>Cravely Admin Dashboard</h1>
          <h2>Laravel, Jquery</h2>
          <ul>
            <li>Converted parts of legacy PHP app into Laravel</li>
            <li>Developed custom admin dashboard, authentication and implemented
              social rating system</li>
          </ul>
          <a class="cool-button" href="http://cravely.com/" target="_blank">Visit Website</a>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
@import "../assets/css/font-awesome.min.css";
</style>

<style>
@import "../assets/css/slick.css";
</style>

<style lang="scss">
@import "../assets/scss/portsub.scss";
</style>

<script>
import JQuery from "jquery";
const $ = JQuery;
import "slick-carousel";

export default {
  name: "Cravely",
  mounted: function() {
    $('.mac-screen-slider').slick({
      autoplay: true,
      autoplaySpeed: 10000,
      arrows: false,
      dots: true,
      fade: true,
      appendDots: $('.mac-screen-slider-dots'),
    });
  }
};
</script>
